import NavBar from '@/components/Nav.vue';

export default {
    name: 'AlbumDetailPage',
    components: {
        NavBar,
    },
    data() {
        return {
            album: {products: [], organization: {}}
        }
    },
    created() {
        this.$http.get('album/' + this.$route.params.id).then(result => {
            this.album = result.data.album;
        })
    }
}